"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowScroll = void 0;
const react_1 = require("react");
const use_raf_state_1 = require("./use-raf-state");
function useWindowScroll() {
    const [state, setState] = (0, use_raf_state_1.useRafState)();
    (0, react_1.useEffect)(() => {
        const handler = () => setState({
            x: window.scrollX,
            y: window.scrollY,
        });
        handler();
        window.addEventListener("scroll", handler, {
            capture: false,
            passive: true,
        });
        return () => window.removeEventListener("scroll", handler);
    }, [setState]);
    return state;
}
exports.useWindowScroll = useWindowScroll;
